import { navCategories } from '@/mocks/nav';

const quickLinks = [
  { href: '#home', label: '首页' },
  { href: '#hot', label: '热门直达' },
  { href: '#categories', label: '主题分类' },
  { href: '#featured', label: '精选推荐' },
  { href: '#guide', label: '找瓜指南' },
  { href: '#faq', label: '常见问题' },
  { href: '#about', label: '关于本站' },
  { href: '#contact', label: '反馈入口' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 py-12 text-background-100 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50">
                <i className="ri-emotion-laugh-line" aria-hidden="true"></i>
              </span>
              <div className="leading-none">
                <p className="font-heading text-base font-bold text-background-50">黑料导航网</p>
                <p className="mt-1 text-xs text-background-200/70">找瓜不迷路</p>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-100/80">
              汇集全网吃瓜黑料入口，提供直达地址、首页链接与网址导航，持续收录最新入口，解决找不到地址的问题。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-100/80">
              <i className="ri-mail-line text-base text-accent-400" aria-hidden="true"></i>
              feedback@heiliaodh.com
            </p>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-bold text-background-50">快速导航</h4>
            <nav aria-label="页脚导航" className="mt-4">
              <ul className="grid grid-cols-2 gap-2.5 sm:grid-cols-2">
                {quickLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/75 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-bold text-background-50">主题分类</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {navCategories.map((category) => (
                <li key={category.id}>
                  <a
                    href="#categories"
                    className="inline-block rounded-full border border-background-100/25 px-3 py-1 text-xs text-background-100/80 transition-colors hover:border-accent-400 hover:text-accent-400"
                  >
                    {category.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-bold text-background-50">收录说明</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-100/75">
              <li>免费收录，无付费置顶</li>
              <li>每日巡检入口可用性</li>
              <li>不生产、不转载内容</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-100/60">© 2026 黑料导航网 · 仅提供入口整理服务</p>
          <p className="max-w-2xl text-xs leading-relaxed text-background-100/60">
            本站不存储、不生产任何内容，所有入口均来自公开渠道整理。请理性吃瓜，自行判断信息真伪。
          </p>
        </div>
      </div>
    </footer>
  );
}